import { c as _c } from "react/compiler-runtime";
import type { Product } from "@/api";
import { Skeleton } from "@osmix/ui/skeleton";
import { expandProductTiles, type TileFilter } from "@/lib/product-tiles";
import { cn } from "@/lib/utils";
import { ProductCard } from "./product-card";

// Responsive product grid: 2 columns on phones, 3 on tablet (744 — кадр «Tablet»),
// 4 on desktop. Зазоры из макета: между колонками 8px (Mobile), 10px (Tablet),
// 20px (Desktop); между рядами не меньше 16px — в Figma (сетки «Подборка от
// OSMIX» и «Мои заказы», 27.10) ряды карточек идут через 16, а 8px на телефоне
// слепляли название с фото следующего ряда (Айталы, photo_105). Used by the
// catalog, shop storefront, and search results alike.
//
// Каждый вариант-цвет — своя плитка (A-09): товар с тремя цветами занимает три
// клетки сетки. `tileFilter` — условия выдачи (цвет, цена, SALE): по фильтру
// «Синий» из многоцветного товара остаётся синяя плитка.
/** Классы сетки карточек — общие с сеткой каталога, где есть реклама. */
export const PRODUCT_GRID_CLASS = "grid grid-cols-2 gap-x-2 gap-y-4 sm:grid-cols-3 sm:gap-x-2.5 lg:grid-cols-4 lg:gap-5";
export function ProductGrid(t0) {
  const $ = _c(8);
  const {
    products,
    tileFilter,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(PRODUCT_GRID_CLASS, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== products || $[3] !== tileFilter) {
    t2 = expandProductTiles(products, tileFilter).map(_temp);
    $[2] = products;
    $[3] = tileFilter;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(tile) {
  return <ProductCard key={tile.key} product={tile.product} tile={tile} />;
}
export function ProductGridSkeleton(t0) {
  const $ = _c(2);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 8 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = <div className={PRODUCT_GRID_CLASS}>{Array.from({
        length: count
      }, _temp2)}</div>;
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
function _temp2(_, i) {
  return <div key={i} className="flex flex-col gap-0.5"><Skeleton className="mb-1.5 aspect-[270/359] w-full rounded-[4px]" /><Skeleton className="h-5 w-16" /><Skeleton className="h-4 w-full" /><Skeleton className="h-4 w-20" /></div>;
}